var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowersBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12033",
    transform: "translate(-497.266 34.5)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h18v18H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 337",
    transform: "translate(497.266 -34.5)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "followers (2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25355"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25354",
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15944",
    d: "M-489.037 51.063h-6.106a.7.7 0 0 1-.668-.917 5.415 5.415 0 0 1 5.145-3.663 5.249 5.249 0 0 1 3.018.946.7.7 0 1 0 .8-1.151 6.669 6.669 0 0 0-1.4-.747 3.573 3.573 0 0 0 1.162-2.357 5.284 5.284 0 0 1 6.7-.547.7.7 0 1 0 .8-1.151 6.669 6.669 0 0 0-1.4-.747 3.579 3.579 0 1 0-4.82-.008q-.147.057-.292.12a6.663 6.663 0 0 0-1.236.71 3.579 3.579 0 1 0-5.742 3.968 6.75 6.75 0 0 0-4.076 4.2 2.106 2.106 0 0 0 2 2.751h6.115a.7.7 0 0 0 0-1.4Zm5.65-15.163a2.176 2.176 0 1 1-2.179 2.179 2.178 2.178 0 0 1 2.179-2.179Zm-7.264 4.8a2.176 2.176 0 1 1-2.176 2.183 2.178 2.178 0 0 1 2.176-2.176Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15945",
    d: "M-479.575 45.964a.7.7 0 0 0-.979.162l-3.459 4.832a.4.4 0 0 1-.577.03l-2.24-2.15a.702.702 0 0 0-.972 1.012l2.242 2.15a1.81 1.81 0 0 0 1.245.5h.119a1.809 1.809 0 0 0 1.287-.67l.024-.031 3.473-4.852a.7.7 0 0 0-.163-.983Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowersBlue);
export default __webpack_public_path__ + "static/media/FollowersBlue.2396fba09116a134cbfdcf1d87ca9333.svg";
export { ForwardRef as ReactComponent };